import { useCampaign } from '../contexts/CampaignContext'
import './TabNav.css'

function TabNav({ activeTab, onTabChange, counts = {} }) {
  const { tabs } = useCampaign()

  return (
    <nav className="tab-nav">
      <div className="tab-nav-inner">
        {tabs.map((tab) => {
          const count = tab.countKey ? counts[tab.countKey] : null
          return (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => onTabChange(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
              {count !== null && count !== undefined && count > 0 && (
                <span className="tab-count">{count}</span>
              )}
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default TabNav
